"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExistingItemHandling = exports.BapiClient = exports.UpdateBasketItemFailureKind = exports.AddToBasketFailureKind = exports.AddToWhistlistFailureKind = void 0;
const createItem_1 = require("../endpoints/basket/createItem");
const deleteItem_1 = require("../endpoints/basket/deleteItem");
const getBasket_1 = require("../endpoints/basket/getBasket");
const updateItem_1 = require("../endpoints/basket/updateItem");
const categories_1 = require("../endpoints/categories/categories");
const categoriesByIds_1 = require("../endpoints/categories/categoriesByIds");
const categoryById_1 = require("../endpoints/categories/categoryById");
const categoryBySlug_1 = require("../endpoints/categories/categoryBySlug");
const filters_1 = require("../endpoints/filters/filters");
const productById_1 = require("../endpoints/products/productById");
const products_1 = require("../endpoints/products/products");
const redirects_1 = require("../endpoints/redirects/redirects");
const productsByIds_1 = require("../endpoints/products/productsByIds");
const addWishlistItem_1 = require("../endpoints/wishlist/addWishlistItem");
const deleteWishlistItem_1 = require("../endpoints/wishlist/deleteWishlistItem");
const getWishlist_1 = require("../endpoints/wishlist/getWishlist");
const execute_1 = require("../helpers/execute");
const ModeledBapiClient_1 = require("./ModeledBapiClient");
const suggestions_1 = require("../endpoints/search/suggestions");
const mappings_1 = require("../endpoints/search/mappings");
const variantsByIds_1 = require("../endpoints/variants/variantsByIds");
const filterValues_1 = require("../endpoints/filters/filterValues");
const typeahead_1 = require("../endpoints/typeahead/typeahead");
const attributeByKey_1 = require("../endpoints/attributes/attributeByKey");
const shopconfiguration_1 = require("../endpoints/shopconfiguration/shopconfiguration");
const productByReferenceKey_1 = require("../endpoints/products/productByReferenceKey");
const resolve_1 = require("../endpoints/search/resolve");
const brands_1 = require("../endpoints/brands/brands");
const brandById_1 = require("../endpoints/brands/brandById");
const campaignById_1 = require("../endpoints/campaigns/campaignById");
const campaigns_1 = require("../endpoints/campaigns/campaigns");
const navigationById_1 = require("../endpoints/navigation/navigationById");
const navigation_1 = require("../endpoints/navigation/navigation");
const promotions_1 = require("../endpoints/promotions/promotions");
const FetchError_1 = require("./FetchError");
const suggestions_2 = require("../endpoints/searchv2/suggestions");
const resolve_2 = require("../endpoints/searchv2/resolve");
var AddToWhistlistFailureKind;
(function (AddToWhistlistFailureKind) {
    AddToWhistlistFailureKind["OnlyOneParameterMustBeSet"] = "OnlyOneParameterMustBeSet";
    AddToWhistlistFailureKind["ItemUnvailable"] = "ItemUnvailable";
    AddToWhistlistFailureKind["MaximumItemCountReached"] = "MaximumItemCountReached";
    AddToWhistlistFailureKind["ItemAlreadyPresent"] = "ItemAlreadyPresent";
    AddToWhistlistFailureKind["Unknown"] = "Unknown";
})(AddToWhistlistFailureKind || (exports.AddToWhistlistFailureKind = AddToWhistlistFailureKind = {}));
function addToWhistListFailureKindFromStatusCode(statusCode) {
    switch (statusCode) {
        case 400:
            return AddToWhistlistFailureKind.OnlyOneParameterMustBeSet;
        case 409:
            return AddToWhistlistFailureKind.ItemAlreadyPresent;
        case 412:
            return AddToWhistlistFailureKind.ItemUnvailable;
        case 413:
            return AddToWhistlistFailureKind.MaximumItemCountReached;
        default:
            return AddToWhistlistFailureKind.Unknown;
    }
}
var AddToBasketFailureKind;
(function (AddToBasketFailureKind) {
    AddToBasketFailureKind["VariantAlreadyPresent"] = "VariantAlreadyPresent";
    AddToBasketFailureKind["ItemUnvailable"] = "ItemUnvailable";
    AddToBasketFailureKind["MaximumItemCountReached"] = "MaximumItemCountReached";
    AddToBasketFailureKind["ItemDataNotFound"] = "ItemDataNotFound";
    AddToBasketFailureKind["ItemAddedWithReducedQuantity"] = "ItemAddedWithReducedQuantity";
    AddToBasketFailureKind["Unknown"] = "Unknown";
})(AddToBasketFailureKind || (exports.AddToBasketFailureKind = AddToBasketFailureKind = {}));
function addToBasketFailureKindFromStatusCode(statusCode) {
    switch (statusCode) {
        case 409:
            return AddToBasketFailureKind.VariantAlreadyPresent;
        case 412:
            return AddToBasketFailureKind.ItemUnvailable;
        case 413:
            return AddToBasketFailureKind.MaximumItemCountReached;
        case 424:
            return AddToBasketFailureKind.ItemDataNotFound;
        case 206:
            return AddToBasketFailureKind.ItemAddedWithReducedQuantity;
        default:
            return AddToBasketFailureKind.Unknown;
    }
}
var UpdateBasketItemFailureKind;
(function (UpdateBasketItemFailureKind) {
    UpdateBasketItemFailureKind["ItemUnvailable"] = "ItemUnvailable";
    UpdateBasketItemFailureKind["BasketItemNotFound"] = "BasketItemNotFound";
    UpdateBasketItemFailureKind["ItemAddedWithReducedQuantity"] = "ItemAddedWithReducedQuantity";
    UpdateBasketItemFailureKind["Unknown"] = "Unknown";
})(UpdateBasketItemFailureKind || (exports.UpdateBasketItemFailureKind = UpdateBasketItemFailureKind = {}));
function updateBasketItemFailureKindFromStatusCode(statusCode) {
    switch (statusCode) {
        case 206:
            return UpdateBasketItemFailureKind.ItemAddedWithReducedQuantity;
        case 404:
            return UpdateBasketItemFailureKind.BasketItemNotFound;
        case 412:
            return UpdateBasketItemFailureKind.ItemUnvailable;
        default:
            return UpdateBasketItemFailureKind.Unknown;
    }
}
class BapiClient {
    constructor(env) {
        this.env = env;
        this.attributes = {
            getByKey: (key) => this.execute((0, attributeByKey_1.createAttributeByKeyEndpointRequest)(key)),
        };
        this.basket = {
            get: (basketKey_1, ...args_1) => __awaiter(this, [basketKey_1, ...args_1], void 0, function* (basketKey, params = {}) {
                const response = yield this.executeWithStatus((0, getBasket_1.getBasketEndpointRequest)(Object.assign(Object.assign({}, params), { basketKey })));
                if (response.statusCode === 200) {
                    return {
                        type: 'success',
                        statusCode: response.statusCode,
                        basket: response.data,
                    };
                }
                else {
                    return {
                        type: 'failure',
                        statusCode: response.statusCode,
                        basket: response.data,
                    };
                }
            }),
            addItem: (basketKey_2, variantId_1, ...args_2) => __awaiter(this, [basketKey_2, variantId_1, ...args_2], void 0, function* (basketKey, variantId, quantity = 1, params = {}) {
                const response = yield this.executeWithStatus((0, createItem_1.createBasketItemRequest)(Object.assign(Object.assign({}, params), { basketKey,
                    variantId,
                    quantity })));
                if (response.statusCode === 200 || response.statusCode === 201) {
                    return {
                        type: 'success',
                        statusCode: response.statusCode,
                        basket: response.data,
                    };
                }
                else {
                    return {
                        type: 'failure',
                        statusCode: response.statusCode,
                        kind: addToBasketFailureKindFromStatusCode(response.statusCode),
                        basket: response.data,
                    };
                }
            }),
            addOrUpdateItems: (basketKey_3, items_1, ...args_3) => __awaiter(this, [basketKey_3, items_1, ...args_3], void 0, function* (basketKey, items, basketParams = {}, options = {
                existingItemHandling: ExistingItemHandling.ReplaceExistingWithCombinedQuantity,
            }) {
                const initialBasketResponse = yield this.basket.get(basketKey, basketParams);
                if (initialBasketResponse.type !== 'success') {
                    throw Error('Failed to get initial basket');
                }
                const client = new BasketMultiOperationsClient(this, initialBasketResponse.basket);
                for (const itemToAdd of items) {
                    const existingBasketItem = client.latestBasket.items.find(item => {
                        var _a, _b, _c;
                        if (item.variant.id !== itemToAdd.variantId) {
                            return false;
                        }
                        if (!options.considerItemGroupForUniqueness) {
                            return true;
                        }
                        return ((_a = item.itemGroup) === null || _a === void 0 ? void 0 : _a.id) === ((_c = (_b = itemToAdd.params) === null || _b === void 0 ? void 0 : _b.itemGroup) === null || _c === void 0 ? void 0 : _c.id);
                    });
                    const { variantId, quantity = 1, params = {} } = itemToAdd;
                    if (existingBasketItem) {
                        if (quantity === 0) {
                            switch (options.existingItemHandling) {
                                case ExistingItemHandling.KeepExisting:
                                case ExistingItemHandling.AddQuantityToExisting:
                                    continue;
                                case ExistingItemHandling.ReplaceExisting:
                                    yield client.deleteItem(existingBasketItem.key, params, variantId);
                                    break;
                                case ExistingItemHandling.ReplaceExistingWithCombinedQuantity:
                                    yield client.deleteItem(existingBasketItem.key, params, variantId);
                                    yield client.addItem(variantId, existingBasketItem.quantity, params);
                                    break;
                            }
                        }
                        else {
                            switch (options.existingItemHandling) {
                                case ExistingItemHandling.KeepExisting:
                                    continue;
                                case ExistingItemHandling.AddQuantityToExisting:
                                    const paramsWithoutDisplayData = Object.assign({}, params);
                                    delete paramsWithoutDisplayData['displayData'];
                                    yield client.updateItem(existingBasketItem.key, existingBasketItem.quantity + quantity, paramsWithoutDisplayData, variantId);
                                    continue;
                                case ExistingItemHandling.ReplaceExisting:
                                    yield client.deleteItem(existingBasketItem.key, params, variantId);
                                    yield client.addItem(variantId, quantity, params);
                                    break;
                                case ExistingItemHandling.ReplaceExistingWithCombinedQuantity:
                                    yield client.deleteItem(existingBasketItem.key, params, variantId);
                                    yield client.addItem(variantId, quantity + existingBasketItem.quantity, params);
                                    break;
                            }
                        }
                    }
                    else {
                        if (quantity > 0) {
                            yield client.addItem(variantId, quantity, params);
                        }
                    }
                }
                const errors = client.errors;
                const latestBasket = client.latestBasket;
                if (errors.length) {
                    return {
                        type: 'failure',
                        basket: latestBasket,
                        errors: errors,
                    };
                }
                return {
                    type: 'success',
                    basket: latestBasket,
                };
            }),
            updateItem: (basketKey_4, itemKey_1, quantity_1, ...args_4) => __awaiter(this, [basketKey_4, itemKey_1, quantity_1, ...args_4], void 0, function* (basketKey, itemKey, quantity, params = {}) {
                const response = yield this.executeWithStatus((0, updateItem_1.updateBasketItemQuantityRequest)(Object.assign(Object.assign({}, params), { basketKey,
                    itemKey,
                    quantity })));
                if (response.statusCode === 200) {
                    return {
                        type: 'success',
                        statusCode: response.statusCode,
                        basket: response.data,
                    };
                }
                else {
                    return {
                        type: 'failure',
                        statusCode: response.statusCode,
                        basket: response.data,
                        kind: updateBasketItemFailureKindFromStatusCode(response.statusCode),
                    };
                }
            }),
            deleteItem: (basketKey, itemKey, params = {}) => this.execute((0, deleteItem_1.deleteBasketItemRequest)(Object.assign(Object.assign({}, params), { basketKey,
                itemKey }))),
        };
        this.categories = {
            getById: (categoryId, parameters = {}) => {
                return this.execute((0, categoryById_1.createCategoryByIdEndpointRequest)(Object.assign(Object.assign({}, parameters), { categoryId })));
            },
            getByIds: (categoryIds, parameters = {}) => {
                return this.execute((0, categoriesByIds_1.createCategoriesByIdsEndpointRequest)(Object.assign(Object.assign({}, parameters), { categoryIds })));
            },
            getByPath: (path, parameters = {}) => {
                return this.execute((0, categoryBySlug_1.createCategoryBySlugEndpointRequest)(Object.assign(Object.assign({}, parameters), { slugPath: path })));
            },
            getRoots: (parameters = {}) => {
                return this.execute((0, categories_1.createCategoriesEndpointRequest)(parameters));
            },
        };
        this.filters = {
            get: (params) => this.execute((0, filters_1.createFiltersEndpointRequest)(params)),
            getValues: (groupName, params) => this.execute((0, filterValues_1.createFilterValuesEndpointRequest)(Object.assign({ groupName: groupName }, params))),
        };
        this.redirects = {
            get: (params = {}) => this.execute((0, redirects_1.createGetRedirectsEndpointRequest)(params)),
            post: (url) => __awaiter(this, void 0, void 0, function* () {
                try {
                    return yield this.execute((0, redirects_1.createPostRedirectEndpointRequest)(url));
                }
                catch (e) {
                    if (e instanceof FetchError_1.FetchError && e.response.status === 404) {
                        return undefined;
                    }
                    throw e;
                }
            }),
        };
        this.products = {
            getById: (productId, params = {}) => this.execute((0, productById_1.createProductByIdEndpointRequest)(Object.assign(Object.assign({}, params), { productId }))),
            getByIds: (productIds_1, ...args_5) => __awaiter(this, [productIds_1, ...args_5], void 0, function* (productIds, params = {}) {
                if (productIds.length === 0) {
                    return [];
                }
                const response = yield this.execute((0, productsByIds_1.createProductsByIdsEndpointRequest)(Object.assign(Object.assign({}, params), { productIds })));
                return response.entities;
            }),
            getByReferenceKeys: (referenceKeys_1, ...args_6) => __awaiter(this, [referenceKeys_1, ...args_6], void 0, function* (referenceKeys, params = {}) {
                const paramsWithReferenceKeys = Object.assign(Object.assign({}, params), { where: {
                        attributes: [
                            {
                                type: 'attributes',
                                key: 'referenceKey',
                                values: referenceKeys,
                            },
                        ],
                    } });
                const response = yield this.execute((0, products_1.createProductsSearchEndpointRequest)(paramsWithReferenceKeys));
                return response.entities;
            }),
            getByReferenceKey: (referenceKey_1, ...args_7) => __awaiter(this, [referenceKey_1, ...args_7], void 0, function* (referenceKey, params = {}) {
                const response = yield this.execute((0, productByReferenceKey_1.createProductByReferenceKeyRequest)(Object.assign(Object.assign({}, params), { referenceKey })));
                if (response.entities.length === 1) {
                    return response.entities[0];
                }
                else if (response.entities.length > 1) {
                    throw new Error(`Got ${response.entities.length} products for a single referenceKey`);
                }
                return null;
            }),
            query: (params = {}) => this.execute((0, products_1.createProductsSearchEndpointRequest)(params)),
        };
        this.wishlist = {
            get: (wishlistKey, params = {}) => this.execute((0, getWishlist_1.getWishlistEndpointRequest)(Object.assign(Object.assign({}, params), { wishlistKey }))),
            addItem: (wishlistKey_1, item_1, ...args_8) => __awaiter(this, [wishlistKey_1, item_1, ...args_8], void 0, function* (wishlistKey, item, params = {}) {
                const response = yield this.executeWithStatus((0, addWishlistItem_1.addWishlistItemEndpointRequest)(Object.assign(Object.assign({}, params), { wishlistKey,
                    item })));
                if (response.statusCode === 200 || response.statusCode === 201) {
                    return {
                        type: 'success',
                        statusCode: response.statusCode,
                        wishlist: response.data,
                    };
                }
                else {
                    return {
                        type: 'failure',
                        statusCode: response.statusCode,
                        kind: addToWhistListFailureKindFromStatusCode(response.statusCode),
                        wishlist: response.data,
                    };
                }
            }),
            deleteItem: (wishlistKey, itemKey, params = {}) => this.execute((0, deleteWishlistItem_1.deleteWishlistEndpointRequest)(Object.assign(Object.assign({}, params), { wishlistKey,
                itemKey }))),
        };
        this.search = {
            suggestions: (term, params = {}) => {
                return this.execute((0, suggestions_1.createSearchSuggestionsEndpointRequest)(Object.assign(Object.assign({}, params), { term })));
            },
            mappings: (term) => {
                return this.execute((0, mappings_1.createrSearchMappingsEndpointRequest)({ term }));
            },
            resolve: (term, params = {}) => {
                return this.execute((0, resolve_1.createSearchResolveEndpointRequest)(Object.assign({ term }, params)));
            },
        };
        this.searchv2 = {
            suggestions: (term, params = {}) => {
                return this.execute((0, suggestions_2.createSearchV2SuggestionsEndpointRequest)(Object.assign(Object.assign({}, params), { term })));
            },
            resolve: (term, params = {}) => {
                return this.execute((0, resolve_2.createSearchV2ResolveEndpointRequest)(Object.assign({ term }, params)));
            },
        };
        this.typeahead = {
            suggestions: (term, params = {}) => {
                return this.execute((0, typeahead_1.createTypeaheadSuggestionsEndpointRequest)(Object.assign(Object.assign({}, params), { term })));
            },
        };
        this.variants = {
            getByIds: (variantIds_1, ...args_9) => __awaiter(this, [variantIds_1, ...args_9], void 0, function* (variantIds, params = {}) {
                if (variantIds.length === 0) {
                    return [];
                }
                const response = yield this.execute((0, variantsByIds_1.createVariantsByIdsEndpointRequest)(Object.assign(Object.assign({}, params), { variantIds })));
                return response.entities;
            }),
        };
        this.shopConfiguration = {
            get: () => __awaiter(this, void 0, void 0, function* () {
                return this.execute((0, shopconfiguration_1.createShopConfigurationRequest)());
            }),
        };
        this.brands = {
            getById: (brandId) => {
                return this.execute((0, brandById_1.createBrandByIdEndpointRequest)(brandId));
            },
            get: (parameters) => {
                return this.execute((0, brands_1.createBrandsEndpointRequest)(parameters));
            },
        };
        this.campaigns = {
            getById: (campaignId) => {
                return this.execute((0, campaignById_1.createCampaignByIdEndpointRequest)(campaignId));
            },
            get: (parameters = {}) => {
                return this.execute((0, campaigns_1.createCampaignsEndpointRequest)(parameters));
            },
        };
        this.navigation = {
            getById: (navigationTreeId, parameters = {}) => {
                return this.execute((0, navigationById_1.createNavigationByIdEndpointRequest)(navigationTreeId, parameters));
            },
            getAll: (parameters = {}) => {
                return this.execute((0, navigation_1.createNavigationAllEndpointRequest)(parameters));
            },
        };
        this.promotions = {
            get: (params = {}) => this.execute((0, promotions_1.createPromotionsEndpointRequest)(params)),
            getByIds: (ids) => __awaiter(this, void 0, void 0, function* () {
                return this.execute((0, promotions_1.createPromotionsEndpointRequest)({
                    ids: ids,
                }));
            }),
        };
        this.shopIdPlacement = env.shopIdPlacement || 'query';
    }
    static withModels(env, mappings) {
        return new ModeledBapiClient_1.ModeledBapiClient(env, mappings);
    }
    execute(bapiCall) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, execute_1.execute)(this.env.host, this.env.shopId, bapiCall, undefined, this.shopIdPlacement, this.env.auth, undefined);
            return response.data;
        });
    }
    executeWithStatus(bapiCall) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, execute_1.execute)(this.env.host, this.env.shopId, bapiCall, true, this.shopIdPlacement, this.env.auth, undefined);
            return {
                data: response.data,
                statusCode: response.statusCode,
            };
        });
    }
}
exports.BapiClient = BapiClient;
var ExistingItemHandling;
(function (ExistingItemHandling) {
    ExistingItemHandling[ExistingItemHandling["KeepExisting"] = 0] = "KeepExisting";
    ExistingItemHandling[ExistingItemHandling["AddQuantityToExisting"] = 1] = "AddQuantityToExisting";
    ExistingItemHandling[ExistingItemHandling["ReplaceExisting"] = 2] = "ReplaceExisting";
    ExistingItemHandling[ExistingItemHandling["ReplaceExistingWithCombinedQuantity"] = 3] = "ReplaceExistingWithCombinedQuantity";
})(ExistingItemHandling || (exports.ExistingItemHandling = ExistingItemHandling = {}));
class BasketMultiOperationsClient {
    constructor(client, latestBasket) {
        this.latestBasket = latestBasket;
        this.errors = [];
        this._client = client;
    }
    deleteItem(itemKey_1) {
        return __awaiter(this, arguments, void 0, function* (itemKey, params = {}, debugVariantId) {
            try {
                const response = yield this._client.basket.deleteItem(this.latestBasket.key, itemKey, params);
                this.updateBasket(response);
            }
            catch (e) {
                this.errors.push({
                    operation: 'delete',
                    basketItemKey: itemKey,
                    variantId: debugVariantId,
                    message: `${e}`,
                });
            }
        });
    }
    addItem(variantId_1) {
        return __awaiter(this, arguments, void 0, function* (variantId, quantity = 1, params = {}) {
            try {
                const response = yield this._client.basket.addItem(this.latestBasket.key, variantId, quantity, params);
                if (response.type == 'failure') {
                    this.errors.push({
                        operation: 'add',
                        kind: response.kind,
                        statusCode: response.statusCode,
                        variantId: variantId,
                    });
                }
                this.updateBasket(response.basket);
            }
            catch (e) {
                this.errors.push({
                    operation: 'add',
                    kind: AddToBasketFailureKind.Unknown,
                    statusCode: -1,
                    variantId: variantId,
                    message: `${e}`,
                });
            }
        });
    }
    updateItem(itemKey_1, quantity_1) {
        return __awaiter(this, arguments, void 0, function* (itemKey, quantity, params = {}, debugVariantId) {
            try {
                const response = yield this._client.basket.updateItem(this.latestBasket.key, itemKey, quantity, params);
                if (response.type == 'failure') {
                    this.errors.push({
                        operation: 'update',
                        basketItemKey: itemKey,
                        statusCode: response.statusCode,
                        kind: response.kind,
                        variantId: debugVariantId,
                    });
                }
                this.updateBasket(response.basket);
            }
            catch (e) {
                this.errors.push({
                    operation: 'update',
                    basketItemKey: itemKey,
                    statusCode: -1,
                    kind: UpdateBasketItemFailureKind.Unknown,
                    variantId: debugVariantId,
                    message: `${e}`,
                });
            }
        });
    }
    updateBasket(basket) {
        if (basket && (basket === null || basket === void 0 ? void 0 : basket.key) == this.latestBasket.key) {
            this.latestBasket = basket;
        }
        else {
            throw Error(`Did not receive valid basket`);
        }
    }
}
